import { useEffect, useState, useContext } from 'react';
import { Button, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../../assets/css/Drivers/DriverSetting/DriverOfferList.css';
import DriverSettingsMasterLayout from '../../../layouts/Drivers/DriverSettingsMasterLayout';
import AppContext from '../../../context/AppContext';

const DriverOfferList = () => {
  const navigate = useNavigate();
  const { baseUrl, authToken } = useContext(AppContext);

  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  const getMyOffers = () => {
    setLoading(true);
    axios
      .post(`${baseUrl}/general/myOffers`, {}, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        setOffers(response.data.offers || []);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    getMyOffers();
  }, []);

  const handleCreateNew = () => {
    navigate('/driver-createoffer');
  };

  // Offer delete karna
  const handleDelete = (offerId) => {
    if (window.confirm('Are you sure you want to delete this offer?')) {
      const formData = new FormData();
      formData.append('offer_id', offerId);

      axios
        .post(`${baseUrl}/general/deleteOffer`, formData, {
          headers: { Authorization: `Bearer ${authToken}` },
        })
        .then((response) => {
          console.log(response.data);
          getMyOffers();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // Offer active/inactive toggle karna
  const handleToggle = (offerId) => {
    const formData = new FormData();
    formData.append('offer_id', offerId);

    axios
      .post(`${baseUrl}/general/toggleOfferStatus`, formData, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      .then((response) => {
        console.log(response.data);
        getMyOffers();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <DriverSettingsMasterLayout screenName={"My Offer List"} centered={true}>
      <div className="driver-offer-list-container">
        <div className="driver-offer-list-content">
          <Container className="driver-offer-list-wrapper">
            {!loading && offers.length > 0 && (
              <Row className="mb-3">
                <Col>
                  <Button className="driver-offer-list-create-btn" onClick={handleCreateNew}>
                    <FaPlus className="me-2" /> Create New Offer
                  </Button>
                </Col>
              </Row>
            )}

            <Row className="mb-3">
              <Col>
                <p className="driver-offer-list-info-text">
                  Create special offers to attract more customers and increase your earnings!
                </p>
              </Col>
            </Row>

            {loading && (
              <Row className="mt-4">
                <Col className="text-center">
                  <Spinner animation="border" />
                </Col>
              </Row>
            )}

            {!loading && (
              <Row className="mt-3">
                <Col>
                  <div className="driver-offer-list-items">
                    {offers.map((offer) => (
                      <div key={offer.id} className="driver-offer-list-card">
                        <div className="driver-offer-list-discount-badge">
                          {offer.discount_percent}% OFF
                        </div>
                        <div className="driver-offer-list-actions">
                          <button
                            className="driver-offer-list-icon-btn driver-offer-list-delete-btn"
                            onClick={() => handleDelete(offer.id)}
                            title="Delete Offer"
                          >
                            <FaTrash />
                          </button>
                        </div>
                        <p className="driver-offer-list-description">
                          {offer.description}
                        </p>
                        <div className="driver-offer-list-usage">
                          <div className="driver-offer-list-usage-item">
                            <span className="driver-offer-list-usage-icon">👥</span>
                            <span className="driver-offer-list-usage-text">
                              {offer.max_users} max users
                            </span>
                          </div>
                        </div>
                        <div className="driver-offer-list-footer">
                          <span className="driver-offer-list-valid-text">
                            Valid till:{' '}
                            {offer.valid_till
                              ? new Date(offer.valid_till).toLocaleDateString()
                              : 'N/A'}
                          </span>
                          <div className="driver-offer-list-toggle-wrapper">
                            <span className="driver-offer-list-status-text">
                              {offer.is_active === 'true' ? 'Active' : 'Inactive'}
                            </span>
                            <Form.Check
                              type="switch"
                              id={`switch-${offer.id}`}
                              checked={offer.is_active === 'true'}
                              onChange={() => handleToggle(offer.id)}
                              className="driver-offer-list-toggle"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            )}

            {!loading && offers.length === 0 && (
              <Row className="mt-5">
                <Col className="text-center">
                  <div className="driver-offer-list-empty-state">
                    <div className="driver-offer-list-empty-icon">🎁</div>
                    <h5 className="driver-offer-list-empty-title">No Offers Yet</h5>
                    <p className="driver-offer-list-empty-text">
                      Create your first offer to attract customers!
                    </p>
                    <Button className="driver-offer-list-create-btn mt-3" onClick={handleCreateNew}>
                      <FaPlus className="me-2" /> Create Your First Offer
                    </Button>
                  </div>
                </Col>
              </Row>
            )}
          </Container>
        </div>
      </div>
    </DriverSettingsMasterLayout>
  );
};

export default DriverOfferList;